import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import './App.css';
import abi from './utils/WavePortal.json';
import { RingLoader } from 'react-spinners'
import { Alert } from '@material-ui/lab'
import { Twitter, LinkedIn } from '@material-ui/icons'
import { BrowserRouter as Router, Link } from 'react-router-dom'

const App = () => {
  const [currentAccount, setCurrentAccount] = useState("");
  const [waveCount, setWaveCount] = useState(0);
  const [allWaves, setAllWaves] = useState([])
  const [message, setMessage] = useState("")
  const [spotify, setSpotify] = useState("")
  const [gif, setGif] = useState("")
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState(false)
  const [alertType, setAlertType] = useState("")
  /**
   * Create a varaible here that holds the contract address after you deploy!
   */
  const contractAddress = "0xFD0d05cf40475150355feFC7ffAA36Dd728BE7C9"
  const contractABI = abi.abi

  const checkIfWalletIsConnected = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        console.log("Make sure you have metamask!");
        return;
      } else {
        console.log("We have the ethereum object", ethereum);
      }

      const accounts = await ethereum.request({ method: 'eth_accounts' });

      if (accounts.length !== 0) {
        const account = accounts[0];
        console.log("Found an authorized account:", account);
        setCurrentAccount(account)
      } else {
        console.log("No authorized account found")
      }
    } catch (error) {
      console.log(error);
    }
  }

  const connectWallet = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        setAlert(true)
        setAlertType("wallet")
        return;
      }

      const accounts = await ethereum.request({ method: "eth_requestAccounts" });
      console.log("Connected", accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (error) {
      console.log(error)
    }
  }



  const wave = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();

        /*
        * You're using contractABI here
        */
        const wavePortalContract = new ethers.Contract(contractAddress, contractABI, signer);

        let count = await wavePortalContract.getTotalWaves();
        console.log("Retrieved total wave count...", count.toNumber());
        setWaveCount(waveCount + count.toNumber())


        const waveTxn = await wavePortalContract.wave(message, spotify, gif);
        console.log("Mining...", waveTxn.hash);
        setMessage("")
        setLoading(true)
        await waveTxn.wait();
        console.log("Mined -- ", waveTxn.hash);

        count = await wavePortalContract.getTotalWaves();
        console.log("Retrieved total wave count...", count.toNumber());

        getAllWaves()
        setLoading(false)

      } else {
        console.log("Ethereum object doesn't exist!");
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
      setAlert(true)
      setAlertType("timeout")
    }
  }

  const spotifyEmbed = (link) => {
    try {
      const split = link.split('/track')
      split.splice(1, 0, "/embed/track")

      console.log(split)
      console.log(split.join(''))
      return split.join('')
    } catch (error) {
      return null
    }
  }



  const giphyEmbed = link => {
    const split = link.split('/')
    return "https://giphy.com/embed/" + split[4]
  }


  const getAllWaves = async () => {
    try {
      const { ethereum } = window;
      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const wavePortalContract = new ethers.Contract(contractAddress, contractABI, signer);

        /*
         * Call the getAllWaves method from your Smart Contract
         */
        const waves = await wavePortalContract.getAllWaves();


        /*
         * We only need address, timestamp, and message in our UI so let's
         * pick those out
         */
        let wavesCleaned = [];
        waves.forEach(wave => {
          wavesCleaned.push({
            address: wave.waver,
            timestamp: new Date(wave.timestamp * 1000),
            message: wave.message,
            spotify: wave.spotify,
            gif: wave.gif
          });
        });

        /*
         * Store our data in React State
         */
        console.log(wavesCleaned)
        setAllWaves(wavesCleaned)

        /**
       * Listen in for emitter events!
       */
        // wavePortalContract.on("NewWave", (from, timestamp, message) => {
        //   console.log("NewWave", from, timestamp, message);

        //   setAllWaves(prevState => [...prevState, {
        //     address: from,
        //     timestamp: new Date(timestamp * 1000),
        //     message: message
        //   }]);
        // });

      } else {
        console.log("Ethereum object doesn't exist!")
      }
    } catch (error) {
      console.log(error);
    }
  }

  const messageFn = e => {
    console.log(e.target.value)
    setMessage(e.target.value)
  }

  const spotifyFn = e => setSpotify(e.target.value)


  const gifFn = e => setGif(e.target.value)

  // const retrieveWaves=async(waves)=>

  useEffect(() => {
    checkIfWalletIsConnected();
  }, [])

  return (
    <>
      <div>
        <div className="mainContainer">

          <div className="dataContainer">
            <div className="header">
              Dapp Book 🔥
        </div>

            {alert && (
              alertType === "wallet" ?

                <Alert severity="error" onClose={() => { setAlert(false) }}>Connect Metamask Wallet</Alert>
                : <Alert severity="error" onClose={() => { setAlert(false) }}>Try again after 10 minutes</Alert>
            )}

            <div className="bio">
              Wassup fam I'm Deepak.
              Connect your Ethereum wallet, tell me a bit about yourself and get a chance to win ethereum 💎
        </div>



            {
              !currentAccount && (
                <button className='connectButton' onClick={connectWallet}>Connect To Wallet
                </button>
              )
            }
            {
              currentAccount && (
                <form id="inputForm">
                  <textarea id="message" rows="4" cols="20" placeholder="Tell me about yourself" onChange={messageFn} />
                  <input id="spotifyInput" placeholder="Put in your favorite song's spotify link" onChange={spotifyFn} />
                  <input id="gifInput" placeholder="Put in your favorite gif's giphy link" onChange={gifFn} />

                </form>
              )
            }

            <button className="waveButton" onClick={wave}>
              Wave at Me
        </button>

            {waveCount > 0 && (
              <div className='waveCount'>
                Total Waves So Far : {waveCount}
              </div>

            )}

            {
              allWaves.length > 0 && allWaves.map((wave, i) => (
                <div className="receivedData">
                  <div className="address" key="i">{i}: {wave.address}</div>
                  <div className="message" key="i"> says "{wave.message}"</div>
                  {wave.spotify !== "" && (
                    spotifyEmbed(wave.spotify) && (

                      <iframe src={spotifyEmbed(wave.spotify)} width="100%" height="90px" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                    )
                  )}
                  {wave.gif && (
                    <iframe src={giphyEmbed(wave.gif) && giphyEmbed(wave.gif)} width="100%" height="480" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
                  )}


                </div>
              ))
            }
            {loading && (
              <div className="loader">
                <p>Miners At Work ⚒️  </p>
                <RingLoader
                  color="#ededed"
                  css={{
                    display: "block",
                    margin: "1rem auto",
                  }}
                />
              </div>
            )

            }

          </div>
        </div>


      </div >
      <footer>
        <Router>
          <div>
            Built by Deepak ft.  <Link to={{ pathname: "https://twitter.com/_buildspace" }} target="_blank" >@buildspace</Link>
          </div>
          <Link to={{ pathname: "https://twitter.com/DKomma" }} target="_blank" ><Twitter fontSize="large" /></Link>
          <Link to={{ pathname: "https://www.linkedin.com/in/deepak-styloria/" }} target="_blank" ><LinkedIn fontSize="large" /></Link>

        </Router>
      </footer>
    </>
  );
}

export default App 